import { API } from 'aws-amplify'

export default {
  getWhistleblowerInfo: organizationName =>
    API.get('PublicAPI', `/reporting/${organizationName}`)
}
